import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { TitleSecondary, ButtonPrimary, SpacerVertical } from 'mage-deps/@klarna/bubble-ui'
import { Message, translator } from 'mage-i18n'
import { EducationAnalytics } from 'education-tools'
import TextArea from './TextArea'

const onClick = (onSumit, track, label) => () => {
  onSumit()
  track({ label })
}

FreeTextFeedbackForm.propTypes = {
  articleId: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired
}

export default function FreeTextFeedbackForm({ articleId, onSubmit }) {
  const t = useSelector(translator)
  const [response, setResponse] = useState('')

  return (
    <>
      <TitleSecondary>
        <Message path="hqm.freeTextFeedback.title" fallback="Help us improve" />
      </TitleSecondary>
      <SpacerVertical small />
      <TextArea
        value={response}
        onChange={setResponse}
        placeholder={t(
          'hqm.freeTextFeedback.placeholder',
          {},
          'Why did you not find this content useful?'
        )}
      />
      <SpacerVertical small />
      <EducationAnalytics
        category="uhqm/free-text-feedback"
        action="submit"
        referenceType="article"
        referenceId={articleId}
      >
        {track => (
          <ButtonPrimary
            onClick={onClick(onSubmit, track, response)}
            size="small"
            disabled={response === ''}
          >
            {t('hqm.freeTextFeedback.submitButton', {}, 'Send')}
          </ButtonPrimary>
        )}
      </EducationAnalytics>
    </>
  )
}
